<template>
  <div class="customer-token">
  </div>
</template>

<script>
export default {
  name: 'CustomerToken',

  metaInfo: {
    title: 'Redirecting...'
  },

  props: ['return'],

  async mounted () {
    try {
      await this.$cookies.remove('token')
      await this.$cookies.set('customer_token', this.$route.params.token)
      await this.$store.dispatch('customer/syncCustomer')
      this.$router.replace(this.$route.query.next || { name: 'CustomerBookingList' })
    } catch (e) {
      this.$router.replace('/')
    }
  }
}
</script>
